import React, { memo, ReactNode } from 'react';

import { markSlot } from './slot-marker';

export type PlayerListTemplateV2HeaderProps = {
  children: ReactNode;
};

/**
 * Screen-level header slot. Rendered at the top of the template container,
 * above the toolbar and list. Accepts any `AppHeader`-style content.
 *
 * This component is intentionally a passthrough so screens keep full control
 * over the header design (back button, title, right actions, ...).
 */
const HeaderComponent = memo(({ children }: PlayerListTemplateV2HeaderProps) => <>{children}</>);
HeaderComponent.displayName = 'PlayerListTemplateV2.Header';

export const Header = markSlot(HeaderComponent, 'header');
